export function pushDataLayerEvent(payload) {
  try {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'fireEvent',
      event_name: 'element_click',
      type: 'ui',
      ...payload,
    });
  } catch (e) {
    console.error('dataLayer push failed:', e);
  }
}
